enum CodatEvents {
  DataSync = 'realtime:codat:dataSync',
}

export default CodatEvents;
